import { render, staticRenderFns } from "./ActivixAccordion.vue?vue&type=template&id=31250b4f&"
import script from "./ActivixAccordion.vue?vue&type=script&lang=js&"
export * from "./ActivixAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports